import {
  rememberModelCacheRequest,
  tabSessionStorage,
} from '@ambr/raven-editor/src/utils/modelCacheMode'
import { initializeAuthStorage } from './initializeAuthStorage'

/** Cleans auth storage before loading the app and reports startup failures. */
const bootstrap = async (): Promise<void> => {
  try {
    initializeAuthStorage()
    // Support links (`?validate-cache`, `?model-cache=off`) must survive the router's redirects.
    rememberModelCacheRequest(window.location.search, tabSessionStorage())
    // Route modules can read auth during evaluation, so load them after cleanup.
    const { startApp } = await import('./startApp')
    startApp()
  } catch (error) {
    // The app and its notification system may not have loaded yet.
    const root = document.getElementById('root')
    if (root) {
      root.textContent = 'Unable to load Motif. Check your connection and refresh the page.'
    }
    // eslint-disable-next-line no-console -- Startup can fail before observability initializes.
    console.error('Unable to start Motif', error)
  }
}

void bootstrap()
